// src/components/autopilot/ICPDisplay.js
import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  TextField,
  Divider
} from '@mui/material';

function ICPDisplay({ icpData, editable = false, onUpdate }) {
  if (!icpData) {
    return (
      <Box sx={{ p: 2 }}>
        <Typography variant="body2" color="text.secondary">
          No ICP data available
        </Typography>
      </Box>
    );
  }

  const sections = [
    {
      title: 'What this person will do',
      key: 'roleDescription',
      placeholder: 'Describe the primary responsibilities and activities...'
    },
    {
      title: 'Critical skills required',
      key: 'criticalSkills',
      placeholder: 'List the essential skills needed...'
    },
    {
      title: 'Other similar roles',
      key: 'similarRoles',
      placeholder: 'Mention alternative or related job titles...'
    },
    {
      title: 'Companies or similar companies',
      key: 'companies',
      placeholder: 'List target companies or company types...'
    },
    {
      title: 'Possible context',
      key: 'context',
      placeholder: 'Additional context, industry, location preferences...'
    }
  ];

  const handleChange = (key, value) => {
    if (onUpdate) {
      onUpdate({
        ...icpData,
        [key]: value
      });
    }
  };

  return (
    <Box sx={{ width: '100%' }}>
      {sections.map((section, index) => (
        <Card key={section.key} sx={{ mb: 2, boxShadow: 2 }}>
          <CardContent>
            <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, color: '#1BE885' }}>
              {index + 1}. {section.title}
            </Typography>
            {editable ? (
              <TextField
                fullWidth
                multiline
                rows={4}
                value={icpData[section.key] || ''}
                onChange={(e) => handleChange(section.key, e.target.value)}
                placeholder={section.placeholder}
                variant="outlined"
                sx={{ mb: 1 }}
              />
            ) : (
              <Typography variant="body1" sx={{ color: '#666', whiteSpace: 'pre-wrap' }}>
                {icpData[section.key] || 'Not specified'}
              </Typography>
            )}
          </CardContent>
        </Card>
      ))}
    </Box>
  );
}

export default ICPDisplay;
